import React from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { userActions } from "../_actions";
import { authHeader } from "../_helpers";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { calculateRank } from '../lib/helper';

import Chemistry from "../assets/che.jpeg";
import Physics from "../assets/phy.jpeg";
import Maths from "../assets/math.jpeg";
import icon_trophy from "../assets/icon_trophy.png";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

class StudentPage extends React.Component {
  constructor() {
    super();
    this.state = {
      listOfQuizAttempted: [],
      selectedQuizId: -1,
      selectedQuizDesciption: '',
      selectedQuizResult: [],
      overallLeaderBoard: [],
      subjectWiseLeaderBoard: [],
      challengeQuizzes: [],
      options: {},
      quizUrls: []
    };
    this.state = {
      isOpen: false
    };
  }

  componentDidMount() {
    this.getQuizAttemptedList();
  }

  handleChange = event => {
    event.persist();
    if (event.target.value != -1) {
      this.findQuizUnderSelectedQuizChallenge(event.target.value);
      this.setState(
        {
          selectedQuizId: event.target.value
        },
        () => {
          this.getSelectedQuizResult();
          this.getQuizSubjectsInfoLinks();
        }
      );
    }
  };

  findQuizUnderSelectedQuizChallenge = quizId => {
    let challengeQuizzes = [];
    let challengeId = -1;
    let attemptedQuizzes = this.state.listOfQuizAttempted;
    let description = this.state.selectedQuizDesciption;
    for (let i = 0; i < attemptedQuizzes.length; i++) {
      if (quizId == attemptedQuizzes[i].QuizID) {
        challengeId = attemptedQuizzes[i].ChallengeID;
        description = attemptedQuizzes[i].Description
      }
    }

    for (let i = 0; i < attemptedQuizzes.length; i++) {
      if (challengeId == attemptedQuizzes[i].ChallengeID) {
        challengeQuizzes.push(attemptedQuizzes[i]);
      }
    }
    this.setState({
      challengeQuizzes: challengeQuizzes,
      selectedQuizDesciption: description
    });
  };

  toggleOpen = () => this.setState({ isOpen: !this.state.isOpen });

  getSelectedQuizResult = () => {
    if (this.state.selectedQuizId != -1) {
      let student = JSON.parse(localStorage.getItem("student"));
      const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + student.data.accessToken
      };
      let url = `http://15.206.132.121:3002/api/getStudentQuizResult?studentEmail=${student
        .data.email}&quizId=${this.state.selectedQuizId}`;
      fetch(url, { headers })
        .then(response => response.json())
        .then(data => {
          let result = data;
          this.createChartData(result.data);
          let listOfQuizAttempted = this.state.listOfQuizAttempted;
          for (let i = 0; i < listOfQuizAttempted.length; i++) {
            if (listOfQuizAttempted[i].QuizID == this.state.selectedQuizId) {
              result.QuizDate = moment(listOfQuizAttempted[i].QuizDate).format(
                "LL"
              );
              result.ChallengeName = listOfQuizAttempted[i].ChallengeName;
              result.ChallengeID = listOfQuizAttempted[i].ChallengeID;
            }
          }
          let sum = 0;
          let resultStudent = result.data[0];
          for (let i = 0; i < resultStudent.length; i++) {
            sum += resultStudent[i].SubjectMarks;
          }
          result.sum = sum;
          this.setState({ selectedQuizResult: result }, () => {
            this.fetchOverallLeaderboard();
            this.fetchSubjectWiseLeaderboard();
          });
        })
        .catch(err => {
          toast.error("Error! Please try again", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
          });
        });
    }
  };

  fetchOverallLeaderboard = () => {
    let student = JSON.parse(localStorage.getItem("student"));
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + student.data.accessToken
    };
    let url = `http://15.206.132.121:3002/api/getChallengeLeaderBoardById?challengeId=${this
      .state.selectedQuizResult.ChallengeID}`;
    fetch(url, { headers })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        let scoreWithRank = calculateRank(...data.data);
        this.setState({
          overallLeaderBoard: scoreWithRank,
        });
      })
      .catch(err => {
        toast.error("Error! Please try again", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
      });
  };

  fetchSubjectWiseLeaderboard = () => {
    let student = JSON.parse(localStorage.getItem("student"));
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + student.data.accessToken
    };
    let url = `http://15.206.132.121:3002/api/getChallengeSubjectLeaderBoard?challengeId=${this
      .state.selectedQuizResult.ChallengeID}`;
    fetch(url, { headers })
      .then(response => response.json())
      .then(data => {
        for (let i = 0; i < data.data.length; i++) {
          data.data[i] = calculateRank(...data.data[i]);
        }
        this.setState({
          subjectWiseLeaderBoard: data.data,
        });
      })
      .catch(err => {
        toast.error("Error! Please try again", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
      });
  };

  getQuizAttemptedList = () => {
    let student = JSON.parse(localStorage.getItem("student"));
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + student.data.accessToken
    };
    let url = `http://15.206.132.121:3002/api/getStudentQuizNames?studentEmail=${student
      .data.email}`;
    fetch(url, { headers })
      .then(response => response.json())
      .then(data => {
        this.setState({ listOfQuizAttempted: data.data });
      })
      .catch(err => {
        toast.error("Error! Please try again", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
      });
  };

  createChartData(resultOriginal) {
    let resultBoth = [...resultOriginal];
    let result = resultBoth[0];
    let resultTopper = resultBoth[1];
    let title = {
      text: "Comparison between me and Topper"
    };
    let yAxis = {
      title: {
        text: "Marks"
      }
    };
    let legend = {
      layout: "vertical",
      align: "right",
      verticalAlign: "middle"
    };
    let responsive = {
      rules: [
        {
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom"
            }
          }
        }
      ]
    };
    let series = [];
    let xAxis = {};
    let totalMe = 0;
    let totalTopper = 0;
    let categories = [];
    let dataMe = [];
    let dataTopper = [];
    for (let i = 0; i < result.length; i++) {
      categories.push(result[i].SubjectName);
      totalMe += result[i].SubjectMarks;
      dataMe.push(result[i].SubjectMarks);
    }
    dataMe.push(totalMe);
    series.push({ name: "Me", data: dataMe });
    categories.push("Total");
    xAxis.categories = categories;

    for (let i = 0; i < resultTopper.length; i++) {
      totalTopper += resultTopper[i].SubjectMarks;
      dataTopper.push(resultTopper[i].SubjectMarks);
    }
    dataTopper.push(totalTopper);
    series.push({ name: "Quiz Topper", data: dataTopper });

    let options = {
      title,
      yAxis,
      xAxis,
      series,
      responsive,
      legend,
      chart: {
        height: 250
      }
    };
    this.setState({
      options
    });
  }

  getQuizSubjectsInfoLinks = () => {
    if (this.state.selectedQuizId != -1) {
      let student = JSON.parse(localStorage.getItem("student"));
      const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + student.data.accessToken
      };
      let url = `http://15.206.132.121:3002/api/getQuizSubjectsInfoLinks?quizId=${this
        .state.selectedQuizId}`;
      fetch(url, { headers })
        .then(response => response.json())
        .then(data => {
          this.setState({ quizUrls: data.data });
        })
        .catch(err => {
          toast.error("Error! Please try again", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
          });
        });
    }
  };

  render() {
    let result = this.state.selectedQuizResult;
    let subjectWiseLeaderBoard = this.state.subjectWiseLeaderBoard;
    const menuClass = `dropdown-menu${this.state.isOpen
      ? " show"
      : ""} extended logout`;
    return (
      <div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <div className="col-lg-12 p-0">
          <header className="header fixed-top clearfix">
            <div className="brand">
              <img
                src="https://www.vidyamandir.com/assets/images/vmc_logo.png"
                alt="VidyaMandir"
                style={{ marginTop: "3%" }}
              />
            </div>
            <div className="nav notify-row" id="top_menu">
              <ul className="nav top-menu">
                <li className="dropdown">
                  <div className="form-group">
                    <div className="col-lg-6">
                      <select
                        className="form-control"
                        id="source"
                        onChange={this.handleChange}
                        style={{ width: "250px" }}
                      >
                        <option value="-1">Select Quiz </option>
                        {this.state.listOfQuizAttempted &&
                          this.state.listOfQuizAttempted.map((quiz, index) => {
                            return (
                              <option key={quiz.QuizID} value={quiz.QuizID}>
                                {quiz.QuizName}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div className="top-nav clearfix">
              <div
                className="nav pull-right top-menu"
                style={{ marginRight: "5px" }}
              >
                <Dropdown>
                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                    <i
                      className="fa fa-user"
                      style={{ paddingLeft: "10%", paddingRight: "10%" }}
                    />
                    {this.props.student ? this.props.student.name : ""}{" "}
                    <b className="caret" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item href="/">
                      <span style={{ padding: "5px" }}>Logout </span>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </header>
        </div>

        <div className="row" style={{ paddingTop: "10%" }}>
          <div className="col-md-3" />
          <div className="col-md-7" />
        </div>
        <div>
          <div className="container">
            {result && result.data ? (
              <div>
                <div className="row">
                  <div className="col-md-8">
                    <section
                      className="panel"
                      style={{ borderRadius: " 4px !important" }}
                    >
                      <div className="wdgt-row row">
                        <div className="col-md-8">
                          <div
                            className="weather-full-info"
                            style={{
                              display: "flex",
                              paddingLeft: "5%",
                              paddingTop: "2%",
                              alignItems: "baseline",
                              flexDirection: "column"
                            }}
                          >
                            <h1 className="text-capital fontChange">
                              {result.data[0][0].QuizName}
                            </h1>
                            <h1 className="text-capital">
                              belongs to {result.ChallengeName}
                            </h1>
                            <h1 className="text-capital">
                              Date : {result.QuizDate}
                            </h1>
                          </div>
                        </div>
                        <div className=" col-md-4 nav" id="top_menu">
                          <ul
                            className="nav top-menu"
                            style={{
                              paddingTop: "4%",
                              display: "flex",
                              justifyContent: "center"
                            }}
                          >
                            <li className="dropdown">
                              <div className="form-group">
                                <div className="col-lg-6 .offset-md-4">
                                  <select
                                    className="form-control"
                                    id="source"
                                    onChange={this.handleChange}
                                    style={{ width: "250px" }}
                                  >
                                    <option value="-1">
                                      Select Challenge Quizzes{" "}
                                    </option>
                                    {this.state.challengeQuizzes &&
                                      this.state.challengeQuizzes.map(
                                        (quiz, index) => {
                                          return (
                                            <option
                                              key={quiz.QuizID}
                                              value={quiz.QuizID}
                                            >
                                              {quiz.QuizName}
                                            </option>
                                          );
                                        }
                                      )}
                                  </select>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="panel-body">
                        <div className="row">
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={this.state.options}
                            containerProps={{ className: "chartContainer " }}
                          />
                        </div>
                      </div>

                      <div className="panel-body" style={{ paddingTop: "3%" }}>
                        <div
                          className="row weather-full-info"
                          style={{ marginBottom: "3%" }}
                        >
                          <div
                            className="col-md-4 today-status"
                            style={{ paddingLeft: "4%" }}
                          >
                            <div>
                              <h1 style={{ color: "#666666" }}>Score</h1>
                              <div
                                className="score-rank"
                                style={{ color: "#343462" }}
                              >
                                {result.sum}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <ul>
                              {result.data[0].map((subject, index) => {
                                return (
                                  <li key={index}>
                                    <h2
                                      style={{
                                        fontWeight: "bold",
                                        color: "#666666"
                                      }}
                                    >
                                      {subject.SubjectName}
                                    </h2>
                                    {(subject.SubjectName == "Maths" ||
                                      subject.SubjectName == "maths") && (
                                        <img src={Maths} />
                                      )}
                                    {(subject.SubjectName == "Chemistry" ||
                                      subject.SubjectName == "chemistry") && (
                                        <img src={Chemistry} />
                                      )}
                                    {(subject.SubjectName == "Physics" ||
                                      subject.SubjectName == "physics") && (
                                        <img src={Physics} />
                                      )}
                                    <div
                                      style={{
                                        color: "#343462",
                                        fontWeight: "bold"
                                      }}
                                    >
                                      {subject.SubjectMarks}
                                    </div>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        </div>
                        <div className="row weather-full-info">
                          <div
                            className="col-md-4 today-status"
                            style={{ paddingLeft: "4%" }}
                          >
                            <div>
                              <h1 style={{ color: "#666666" }}>Rank</h1>
                              <div
                                className="score-rank"
                                style={{ color: "#343462" }}
                              >
                                {result.data[0][0].TotalRank}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <ul>
                              {result.data[0].map((subject, index) => {
                                return (
                                  <li key={index}>
                                    <h2
                                      style={{
                                        fontWeight: "bold",
                                        color: "#666666"
                                      }}
                                    >
                                      {subject.SubjectName}
                                    </h2>
                                    {(subject.SubjectName == "Maths" ||
                                      subject.SubjectName == "maths") && (
                                        <img src={Maths} />
                                      )}
                                    {(subject.SubjectName == "Chemistry" ||
                                      subject.SubjectName == "chemistry") && (
                                        <img src={Chemistry} />
                                      )}
                                    {(subject.SubjectName == "Physics" ||
                                      subject.SubjectName == "physics") && (
                                        <img src={Physics} />
                                      )}
                                    <div
                                      style={{
                                        color: "#343462",
                                        fontWeight: "bold"
                                      }}
                                    >
                                      {subject.SubjectRank}
                                    </div>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </section>
                    <section
                      className="panel"
                      style={{ borderRadius: " 4px !important" }}
                    >
                      <div className="wdgt-row row">
                        <div>
                          <div
                            className="weather-full-info"
                            style={{
                              display: "flex",
                              paddingLeft: "5%",
                              paddingTop: "2%",
                              alignItems: "baseline",
                              flexDirection: "column"
                            }}
                          >
                            <h1 className="text-capital fontChange ">
                              {result.data[0][0].QuizName}
                            </h1>
                            <h1 className="text-capital" style={{ textAlign: "left", marginRight: "5%" }}>{this.state.selectedQuizDesciption}</h1>
                          </div>
                        </div>
                      </div>
                      <div
                        className="panel-body pl-4"
                        style={{ paddingTop: "3%" }}
                      >
                        {this.state.quizUrls &&
                          this.state.quizUrls.length > 0 ? (
                            this.state.quizUrls.map((subject, index) => {
                              return (
                                <div
                                  className="row weather-full-info"
                                  style={{ marginBottom: "3%" }}
                                >
                                  <div className="col-md-2">
                                    <h4 style={{ color: "#666666" }}>
                                      {subject.SubjectName}
                                    </h4>
                                  </div>
                                  <div className="col-md-3" style={{ marginRight: "8px" }}>
                                    <a
                                      href={subject.TestPaperLinks}
                                      target="_blank"
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-info "
                                      >
                                        <i className="fa fa-download" style={{ position: "static", color: "white", marginRight: "3px" }}></i>
                                        Download Test Paper

                                      </button>
                                    </a>
                                  </div>
                                  <div className="col-md-3">
                                    <a
                                      href={subject.PdfSolutionLinks}
                                      target="_blank"
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-info "
                                      >
                                        <i className="fa fa-download" style={{ position: "static", color: "white", marginRight: "3px" }}></i>

                                        Download Solutions
                                    </button>
                                    </a>
                                  </div>
                                  <div className="col-md-3">
                                    <a
                                      href={subject.VideoSolutionLinks}
                                      target="_blank"
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-info "
                                      >
                                        Watch Video Solutions
                                    </button>
                                    </a>
                                  </div>
                                </div>
                              );
                            })
                          ) : null}
                      </div>
                    </section>
                  </div>

                  <div className="col-md-4">
                    <div className="profile-nav alt">
                      <section
                        className="panel"
                        style={{
                          borderRadius: " 4px"
                        }}
                      >
                        <div className="row">
                          <div className="col-md-7 pr-0">
                            <div className="img-heading alt clock-row terques-bg">
                              <img
                                src={icon_trophy}
                                className="challenge-img"
                              />
                            </div>
                          </div>
                          <div className="col-md-5 pl-0">
                            <div className="user-heading alt clock-row terques-bg">
                              <h1 className="text-capital">Challenge</h1>
                              <p className="text-left text-capital">
                                Leaderboard
                              </p>
                              <p className="text-left text-capital">Overall</p>
                            </div>
                          </div>
                        </div>
                        <div className="table-scroll">
                          <table
                            style={{
                              width: "100%"
                            }}
                            className="leader-table"
                          >
                            <tbody>
                              {this.state.overallLeaderBoard &&
                                this.state.overallLeaderBoard.map(
                                  (student, index) => {
                                    return (
                                      <tr>
                                        <td>{student.Name}</td>
                                        <td>{student.TotalMarks}</td>
                                        <td>
                                          <span>{student.rank}</span>
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                            </tbody>
                          </table>
                        </div>
                      </section>
                    </div>
                    {subjectWiseLeaderBoard &&
                      subjectWiseLeaderBoard.length > 0 &&
                      subjectWiseLeaderBoard.map((subject, index) => {
                        return (
                          <div className="row">
                            <div className="col-md-12 ">
                              <div className="profile-nav alt">
                                <section
                                  className="panel"
                                  style={{
                                    borderRadius: " 4px"
                                  }}
                                >
                                  <div className="row">
                                    <div className="col-md-7 pr-0">
                                      <div className="img-heading alt clock-row terques-bg">
                                        <img
                                          src={icon_trophy}
                                          className="challenge-img"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-5 pl-0">
                                      <div className="user-heading alt clock-row terques-bg">
                                        <h1 className="text-capital">
                                          Challenge
                                        </h1>
                                        <p className="text-left text-capital">
                                          Leaderboard
                                        </p>
                                        {subject[0] && subject[0].SubjectName}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="table-scroll">
                                    <table
                                      style={{
                                        width: "100%"
                                      }}
                                      className="leader-table"
                                    >
                                      <tbody>
                                        {subject.map((s, index) => {
                                          return (
                                            <tr>
                                              <td>{s.StudentName}</td>
                                              <td>{s.TotalMarks}</td>
                                              <td>
                                                <span>{s.rank}</span>
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                </section>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            ) : (
                <h2 style={{ textAlign: "center" }}>
                  Please select one of the attempted Quiz
                </h2>
              )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let student = state.studentLogin.student
    ? state.studentLogin.student.data
    : {};

  return {
    student
  };
}

const connectedStudentPage = connect(mapStateToProps)(StudentPage);
export { connectedStudentPage as StudentPage };
